const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/calibration')({
  beforeLoad: requireCapabilities(has => has('calibration.read') || has('calibration.program.read')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});